<template>
  <div>
    <div class="DIV2">
      <span class="DIV4" v-show="inputObject.isMustInput">*</span>{{inputObject.label}}
    </div>
    <div class="DIV3"><el-input v-bind="inputObject" v-model="inputObject.value" :disabled="inputObject.dataForm"></el-input></div>
  </div>
</template>
<script>
  export default {
    props: {
      inputObject:{
        type:Object
      }
    },
    data () {
      return {

      }
    },
    methods:{

    }
  }
</script>
<style scoped>
  @import '../../assets/common.css';
</style>



// WEBPACK FOOTER //
// src/components/Input/index.vue